module.exports = __webpack_public_path__ + "img/login_biaoti.9e069f21.png";